import { Fragment, useContext, useState } from "react";
import { Button } from "rizzui";
import { PrivilegeContext } from "../../../components/priviledge/PriviledgeProvider";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import PageHeader from "../../../layout/shared/page-header";
import { menuRoutes } from "../../../router/menu";
import cn from "../../../utils/classNames";
import VehiclesList from "./VehiclesList";

const VehiclesListWrapper = () => {
    const [openFormDrawer, setOpenFormDrawer] = useState(false);
    const [vehicleSelected, setVehicleSelected] = useState(null);
    const { userCan } = useContext(PrivilegeContext);

    const breadCrumb = [
        { name: 'Administración' },
        { name: 'Vehículos', href: menuRoutes.vehicles.path },
        { name: 'Listado' }
    ];

    return (
        <Fragment>
            <FiltersProvider>
                <PageHeader title="Listado de vehículos" breadcrumb={breadCrumb}>
                    {
                        userCan('create', 'vehicle') &&
                        (
                            <Button
                                color="primary"
                                onClick={() => { 
                                    setOpenFormDrawer(true);
                                    setVehicleSelected(null);
                                }}
                                className={cn(['mt-4 md:mt-0'])}
                            >
                                Crear vehículo
                            </Button>
                        )
                    }
                </PageHeader>
                <VehiclesList 
                    openFormDrawer={openFormDrawer} 
                    setOpenFormDrawer={setOpenFormDrawer} 
                    vehicleSelected={vehicleSelected} 
                    setVehicleSelected={setVehicleSelected} 
                />
            </FiltersProvider>
        </Fragment>
    );
};

export default VehiclesListWrapper;